import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const AboutUs = () => {
    return (
        <div className="terms-wrapper py-5">
            <Container className="rounded shadow p-4 bg-white">
                <Row>
                    <Col>
                        <h2 className="text-center fw-bold mb-4">RASUTRIP - Your Journey Begins Here</h2>

                        <h5 className="fw-bold mt-4">About RASUTRIP</h5>
                        <p>
                            Discover the difference that makes travel effortless.
                            At RASUTRIP, we don't just book your travel – we craft experiences.
                            Born from a passion to revolutionize how India travels, we've built
                            more than just a platform; we've created a trusted companion for every
                            journey you take.
                        </p>
                        <p>
                            From the bustling streets of Mumbai to the serene backwaters of Kerala,
                            from quick business hops to dream vacation escapes – RASUTRIP transforms
                            travel planning from a chore into a delightful experience.
                        </p>

                        <h5 className="fw-bold mt-4">Our Complete Travel Solutions</h5>
                        <h6 className="fw-bold mt-3">Flight Booking - Domestic & International</h6>
                        <ul>
                            <li>Instant Confirmations with real-time availability</li>
                            <li>Best Price Guarantee - find a lower price, we'll match it</li>
                            <li>Smart Filters to find exactly what you need</li>
                            <li>Flexible Booking Options with easy modifications</li>
                        </ul>

                        <h6 className="fw-bold mt-3">Bus Booking - Intercity & Intrastate</h6>
                        <ul>
                            <li>Premium Bus Partners across India</li>
                            <li>Wide Network Coverage connecting major cities</li>
                            <li>Comfortable Seating Options from sleeper to luxury</li>
                            <li>Easy Cancellation with transparent refund policies</li>
                        </ul>

                        <h6 className="fw-bold mt-3">Hotel Booking - Budget to Luxury</h6>
                        <ul>
                            <li>Handpicked Properties verified for quality</li>
                            <li>Exclusive Deals not available elsewhere</li>
                            <li>Instant Booking with immediate confirmation</li>
                            <li>Guest Reviews from real travelers</li>
                        </ul>

                        <h6 className="fw-bold mt-3">Corporate Travel Services</h6>
                        <ul>
                            <li>Dedicated Account Manager for your business needs</li>
                            <li>Streamlined Booking Process for teams</li>
                            <li>Expense Management with detailed reporting</li>
                            <li>24/7 Business Support for urgent travel needs</li>
                        </ul>

                        <h5 className="fw-bold mt-4">Why Thousands Choose RASUTRIP</h5>
                        <ul>
                            <li><strong>One Platform, Endless Possibilities:</strong> Book everything in one place.</li>
                            <li><strong>Transparent Pricing:</strong> No hidden fees or last-minute charges.</li>
                            <li><strong>Your Safety, Our Priority:</strong> Secure data and payment protection.</li>
                            <li><strong>Always Available:</strong> 24/7 support from our expert team.</li>
                            <li><strong>Personalized Service:</strong> Tailored recommendations based on your travel needs.</li>
                        </ul>

                        <h5 className="fw-bold mt-4">What Makes Us Different</h5>
                        <ul>
                            <li><strong>Human Touch in a Digital World:</strong> Travel experts are just a call away.</li>
                            <li><strong>Seamless Experience:</strong> Simple, smooth process from browsing to boarding.</li>
                            <li><strong>Flexibility First:</strong> Easy modifications and cancellations.</li>
                            <li><strong>Quality Partnerships:</strong> Verified service providers only.</li>
                        </ul>

                        <h5 className="fw-bold mt-4">Our Vision & Mission</h5>
                        <p><strong>Our Vision:</strong> To make travel accessible, affordable, and enjoyable for every Indian – turning wanderlust into wonderful memories.</p>
                        <p><strong>Our Mission:</strong> Simplifying travel through innovation, reliability, and unmatched customer service – one journey at a time.</p>

                        <h5 className="fw-bold mt-4">Get Started Today</h5>
                        <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
                            Ready to experience travel the <strong>RASUTRIP</strong> way?
                            <br />
                            📱 Download our app or 🌐 visit our website:&nbsp;
                            <a
                                href="http://rasutrip.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#000', textDecoration: 'none' }}
                            >
                                rasutrip.com
                            </a>
                            <br />
                            📞 Call us anytime – We're here 24/7:&nbsp;
                            <a
                                href="tel:9266424809"
                                style={{ color: '#000', textDecoration: 'none' }}
                            >
                                9266424809
                            </a>
                            <br />
                            💬 Chat with our experts – Get instant assistance
                        </p>
                        <h5 className="fw-bold mt-4">Join the RASUTRIP Family</h5>
                        <p>
                            Thousands of happy travelers can't be wrong.
                            Join them in discovering why RASUTRIP is India's fastest-growing travel platform.
                            Your next adventure is just a click away.
                        </p>

                        <h5 className="fw-bold mt-4">Corporate Partnerships</h5>
                        <p>
                            Transform your business travel experience.
                            Contact our corporate solutions team for customized travel management that lets your team focus on what they do best.
                        </p>

                        <p className="text-center mt-5 fw-semibold">RASUTRIP - Where Every Journey Matters</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AboutUs;
